import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const TableRow = () => (
    <tr>
        <th scope="row">
          <img width="50px" src="https://www.gertec.com.br/wp-content/uploads/2017/05/ppc910_img06.png" alt="GERTEC PPC930" />
          Gertec PPC930
        </th>
        <td>
            SW0000001
        </td>
        <td>
            IPC1303TB30001BA
        </td>
        <td>
            3 minutos atrás
        </td>
    </tr>
)

export default class Terminals extends Component {
    render () {
        return (
            <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Terminais</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Modelo</th>
                    <th scope="col">Número Lógico</th>
                    <th scope="col">Serial Number</th>
                    <th scope="col">Último Pedido</th>
                  </tr>
                </thead>
                <tbody>
                  <TableRow />
                </tbody>
              </table>
            </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/Terminals/index.js